


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { AssetAttribute } from 'performo-api';

@Component({})
export default class AssetAttributes extends Vue {
  @Prop({ required: true }) attributes!: { string: AssetAttribute[] };

  private sortedAttributes = this.sortObject(this.attributes);
  private panel: number[] = [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private sortObject(obj: Record<string, any>) {
    return (
      Object.keys(obj)
        .sort()
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce(function (result: Record<string, any>, key) {
          result[key] = obj[key];
          return result;
        }, {})
    );
  }

  private open() {
    this.panel = [...Object.keys(this.attributes)].map((k, i) => i);
  }
  private close() {
    this.panel = [];
  }
}
